document.addEventListener('DOMContentLoaded', function() {
  // Add to cart functionality
  $(document).on('click', '.add-to-cart', function(e) {
    e.preventDefault();
    const btn = $(this);
    const productID = btn.attr('data-variant-id');

    if (!productID) return;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: productID,
        quantity: 1
      },
      success: function(response) {
        btn.text('Added to Cart!');
        notificationx();
        cartRefresh();
        setTimeout(() => {
          btn.text('Add to Cart');
        }, 2000);
      },
      error: function(XMLHttpRequest, textStatus) {
        console.error('Error adding product to cart:', textStatus);
        btn.text('Error');
        setTimeout(() => {
          btn.text('Add to Cart');
        }, 2000);
      }
    });
  });
});

function cartRefresh() {
  $.getJSON('/cart.json').then((cart) => {
    fetch('cart?view=item')
      .then((response) => response.text())
      .then((text) => {
        console.log(text);
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;
        const totalPrice = sectionInnerHTML.querySelector('#CartDrawer p.totals__total-value').innerHTML;
        
        $('#CartDrawer').html(cartFormInnerHTML);
        $('cart-drawer').removeClass('is-empty');
        $('cart-drawer-items').removeClass('is-empty');
        
        if ($('#cart-icon-bubble .cart-count-bubble').length === 0) {
          const cartNumber = document.createElement('div');
          cartNumber.className = 'cart-count-bubble';
          cartNumber.innerHTML = `
            <span aria-hidden="true">${cart.item_count}</span>
            <span class="visually-hidden">${cart.item_count} items</span>
          `;
          $('#cart-icon-bubble').append(cartNumber);
        } else {
          $('.cart-count-bubble span[aria-hidden="true"]').each((_, count) => $(count).text(cart.item_count));
        }
        
        $('#cart-icon-bubble')[0].click();
        $('#CartDrawer-Overlay').on('click', () => {
          $('cart-drawer').removeClass('active');
          $('body').removeClass('overflow-hidden');
        });
      });
  });
}

function notificationx() {
  $.getJSON('/cart.json').then(cart => {
    var item = document.querySelector('#cart-notification-product');
    var button = document.querySelector('#cart-notification-button');
    const cartBubble = `<div class="cart-count-bubble"><span aria-hidden="true">${cart.item_count}</span></div>`;
    var notification = document.getElementById('cart-notification');

    // Assuming the first item in the cart is the one to display
    var cartItem = cart.items[0];

    var html = `
      <div class="cart-notification-product__image global-media-settings">
        <img src="${cartItem.image}" alt="${cartItem.title}" width="70" height="105" loading="lazy">
      </div>
      <div>
        <h3 class="cart-notification-product__name h4">${cartItem.title}</h3>
        <dl>
          <div class="product-option">
            <dt>Plant Size:</dt>
            <dd>${cartItem.variant_title}</dd>
          </div>
        </dl>
      </div>
    `;

    item.innerHTML = html;
    button.innerText = `View my cart (${cart.item_count})`;

    if ($('.cart-count-bubble').length > 0) {
      $('.cart-count-bubble span').text(cart.item_count);
    } else {
      $('#cart-icon-bubble').append(cartBubble);
    }

    notification.classList.add('animate', 'active');
    notification.addEventListener('transitionend', () => {
      notification.focus();
      trapFocus(notification);
    }, { once: true });
  });
}

// $(document).ready(function() {
//   // Event listener for the add-to-cart button
//   $('.add-to-cart').on('click', function(e) {
//     e.preventDefault();
//     const btn = $(this);
//     const productID = btn.attr('data-variant-id');

//     if (!productID) return;

//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       dataType: 'json',
//       data: {
//         id: productID,
//         quantity: 1
//       },
//       success: function(response) {
//         btn.text('Added to Cart!');
//         notificationx();
//         cartRefresh();
//         setTimeout(() => {
//           btn.text('Add to Cart');
//         }, 2000);
//       },
//       error: function(XMLHttpRequest, textStatus) {
//         console.error('Error adding product to cart:', textStatus);
//         btn.text('Error');
//         setTimeout(() => {
//           btn.text('Add to Cart');
//         }, 2000);
//       }
//     });
//   });
// });